'use strict';

/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */
var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */
  var defaultSettings = {
    method: 'scroll',
    container: '.AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  };
  this.settings = Object.assign(defaultSettings, settings);

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.checkAndLoadIfInViewport = this.checkAndLoadIfInViewport.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  document.addEventListener('load', this.checkAndLoadIfInViewport);

  this.initialize();
};


Ajaxinate.prototype.checkAndLoadWithInterval = function checkAndLoadWithInterval() {
  const interval = setInterval(() => {
    const productGrid = document.querySelector('.AjaxinateContainer');
    const products = productGrid ? productGrid.querySelectorAll('.grid__item') : [];

    if (products.length > 0) {
      clearInterval(interval);
      this.checkAndLoadIfInViewport(); 
    } else {
      console.log('Checking for products...');
    }
  }, 500);
};


function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

Ajaxinate.prototype.checkAndLoadIfInViewport = function checkAndLoadIfInViewport() {
  if (this.paginationElement && isInViewport(this.paginationElement)) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.checkInitialProducts = function checkInitialProducts() {
  if (this.containerElement) {
    const currentProductCount = this.containerElement.querySelectorAll('.grid__item').length;

    if (currentProductCount < 12) {
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();

    this.checkAndLoadWithInterval();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var parser = new DOMParser();
      var responseDoc = parser.parseFromString(this.request.responseText, "text/html");

      var newContainer = responseDoc.querySelector(this.settings.container);
      var newPagination = responseDoc.querySelector(this.settings.pagination);

      if (newContainer && newContainer.children.length > 0) {
        this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);

        newContainer.querySelectorAll("script").forEach(oldScript => {
          const newScript = document.createElement("script");
          if (oldScript.src) {
            newScript.src = oldScript.src;
            newScript.async = true;
          } else {
            newScript.textContent = oldScript.textContent;
          }
          document.body.appendChild(newScript);
          oldScript.remove();
        });
      }

      if (newPagination) {
        this.paginationElement.innerHTML = newPagination.innerHTML;
        this.nextPageLinkElement = this.paginationElement.querySelector('a');
        if (this.nextPageLinkElement) {
          this.nextPageUrl = this.nextPageLinkElement.href;
        }
      } else {
        this.paginationElement.remove();
        this.nextPageUrl = null;
      }

      const currentProductCount = this.containerElement.querySelectorAll('.grid__item').length;
      if (currentProductCount < 12 && this.nextPageUrl) {
        this.loadMore();
      }

      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(responseDoc);
      }

      this.initialize();
    } else if (this.request.readyState === 4 && this.request.status !== 200) {
      console.error('Cannot load more products. Status: ' + this.request.status);
    }
  }.bind(this);

  if (this.nextPageUrl) {
    this.request.open('GET', this.nextPageUrl);
    this.request.responseType = 'text';
    this.request.send();
  } else {
    console.warn('Not found next page URL. Cannot load more products.');
  }
};


Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};